module.exports = __webpack_public_path__ + "img/sofyre-user-manual.07880aa4.png";